import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface AnimatedNumberProps {
  value: number;
  duration?: number;
  className?: string;
}

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ value, duration = 1 }) => {
  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        height: '1em', // Ensures space for the number
        lineHeight: '1em',
        verticalAlign: 'middle',
        overflow: 'hidden',
      }}
    >
      <AnimatePresence initial={false}>
        <motion.span
          key={value}
          initial={{ y: 20, opacity: 0, position: 'absolute', left: 0, right: 0 }}
          animate={{ y: 0, opacity: 1, position: 'absolute', left: 0, right: 0 }}
          exit={{ y: -20, opacity: 0, position: 'absolute', left: 0, right: 0 }}
          transition={{ duration, ease: 'easeInOut' }}
          style={{ width: '100%', textAlign: 'center' }}
        >
          {value}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export default AnimatedNumber; 